import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useAppState } from '../../store/appstate';
import { SessionOrganization } from '../../types/SessionUser';

interface OrganizationFlagValue {
    organizations?: string[];
}

export function useIsFlagEnabled(flag: string, defaultValue = false): boolean {
    const ldClient = useLDClient();

    if (!ldClient) {
        return defaultValue;
    }

    return ldClient.variation(flag, defaultValue);
}

export function useIsFlagEnabledForOrg(flag: string, defaultValue = false): boolean {
    const ldClient = useLDClient();
    const organizationId = useAppState<SessionOrganization | undefined>(
        s => s.session.user?.organization
    )?.id;

    if (!ldClient) {
        return defaultValue;
    }

    if (!organizationId) {
        return defaultValue;
    }

    const flagValue = ldClient.variation(flag, defaultValue);
    if (typeof flagValue === 'boolean') {
        return flagValue;
    }

    if (isOrganizationFlagValue(flagValue)) {
        return (
            (flagValue.organizations?.includes('all') ||
                flagValue.organizations?.includes(organizationId)) ??
            defaultValue
        );
    }

    return defaultValue;
}

function isOrganizationFlagValue(value: unknown): value is OrganizationFlagValue {
    return (
        typeof value === 'object' &&
        value !== null &&
        'organizations' in value &&
        (Array.isArray((value as OrganizationFlagValue).organizations) ||
            (value as OrganizationFlagValue).organizations === undefined)
    );
}
